import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { AirconServiceCostCalculator } from '../../../components/index/service-category/aircon-service/AirconServiceCostCalculator'
import AirconPricing from '@/index/service-category/aircon-service/AirconPricing'
import { airconCostCalculation } from 'js/aircon-cost'
import ServiceWarranty from '@/index/service-category/aircon-service/ServiceWarranty'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import { RequestProvider } from 'context/RequestContext'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { AnimatePresence } from 'framer-motion'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { useState } from 'react'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'


// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-23'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = contentDate(CONTENT_REVIEWED)
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray

    const currencyCd = "SGD"
        
    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)
    
  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        standardServicing,
        annualServicing,
        chemicalServicing,
        overhaulServicing,
        currencyCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}
export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const currencyCd = props.currencyCd
    const brandName = "Mitsubishi";
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)
    
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")

  return (
    <>
      <Head>
        <title>Mitsubishi Air Conditioner Servicing & Repair in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG offers professional Mitsubishi aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Mitsubishi air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/mitsubishi-electric" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Mitsubishi Air Conditioner Servicing & Repair in Singapore`}/>
        <meta property="og:description" content="StringsSG offers professional Mitsubishi aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Mitsubishi air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T09:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/mitsubishi-logo.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/mitsubishi-logo.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/mitsubishi-electric"/>
        <meta name="twitter:title" content={`Mitsubishi Air Conditioner Servicing & Repair in Singapore`}/> 
        <meta name="twitter:description" content="StringsSG offers professional Mitsubishi aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Mitsubishi air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/mitsubishi-electric',
            pageName: 'Mitsubishi Air Conditioner Servicing & Repair in Singapore',
            description: 'StringsSG offers professional Mitsubishi aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Mitsubishi air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon.',
            serviceName: 'Mitsubishi Electric Aircon Servicing & Repair Singapore',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/mitsubishi-logo.jpg',
            datePublished: '2025-01-09T09:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Mitsubishi Electric',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/mitsubishi-electric"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="blog/living/mitsubishi-logo.jpg"
                    title="Mitsubishi Aircon Servicing Singapore"
                />
            </RequestProvider>
            <section className='max-w-5xl mx-auto py-10 px-2 grid md:grid-cols-2 gap-5 items-center'>
                <header className='space-y-8 '>
                    {/* H2: the hero above already renders this page's H1. */}
                    <h2 className='text-3xl md:text-4xl font-semibold text-center'>Mitsubishi Aircon Servicing & Repair in Singapore</h2>
                    <p className='leading-8 space-y-3'>
                        StringsSG offers professional Mitsubishi aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services 
                        for Mitsubishi air conditioning units. Open a request for reliable and efficient servicing to ensure optimal performance of your Mitsubishi aircon.
                    </p>
                </header>
                <div className='relative flex justify-center max-w-md mx-auto'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/living/mitsubishi-tag.png"}
                            height={272}
                            width={300}
                            style={{objectFit: 'contain', height:"auto", width:"auto"}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Mitsubishi Aircon Servicing '
                    />          
                </div>
            </section>
            <AirconPricing
                standardServicing={standardServicing} 
                annualServicing={annualServicing} 
                chemicalServicing={chemicalServicing} 
                overhaulServicing={overhaulServicing} 
                gasTopup={[{type: 'R22', priceRange: 'S$40 - S$100'}, {type: 'R410A', priceRange: 'S$90 - S$150'}, {type: 'R32', priceRange: 'S$120 - S$220'}]}  
                currencyCd={currencyCd}
            />
            <section className='py-5 bg-slate-600'>
                <div className='max-w-2xl mx-auto text-center text-white py-5 space-y-4 px-2'>   
                    <h2 className='text-2xl font-bold'>Mitsubishi Aircon Servicing Cost Calculator</h2>                
                    <p className='leading-7'>Use this calculator to get an estimation of how much you should be paying for Mitsubishi Aircon Servicing in Singapore.</p>                       
                </div>
                <AirconServiceCostCalculator requestCategorySettings={requestCategorySettings}/>
            </section>
            <section className='max-w-5xl mx-auto py-10'>
                <AirconGeneralServiceProcess />
            </section> 
            <ServiceWarranty brand={brandName} />
            <section className="max-w-5xl mx-auto py-12 px-4 space-y-12 text-gray-800">
                {/* Intro Section */}
                <header className="text-center space-y-4">
                    <h2 className="text-3xl md:text-4xl font-bold uppercase">
                    Mitsubishi Electric Aircon Models
                    </h2>
                    <p className="text-md md:text-lg max-w-3xl mx-auto leading-7">
                    StringsSG specializes in servicing and installing a complete range of Mitsubishi Electric air conditioners in Singapore—whether it&apos;s a split, multi-split, or ducted system.
                    </p>
                    <div className="relative h-96 w-full mt-6">
                    <Image
                        className="rounded-lg"
                        src={s3Static + "blog/living/mitsubishi-electric-aircon.png"}
                        fill
                        sizes="(max-width: 768px) 100vw, 33vw"
                        style={{ objectFit: "cover" }}
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                        alt="Mitsubishi Electric Air Conditioner Units"
                    />
                    </div>
                </header>

                {/* Aircon Model Cards */}
                <section className="space-y-10">
                    <div className="grid md:grid-cols-2 gap-6">
                    {/* R410a Single Split */}
                    <article className="border shadow-lg rounded-lg p-5 space-y-4 hover:shadow-xl transition duration-300">
                        <h3 className="text-xl md:text-2xl font-bold text-center">
                            Starmex R410a Single Split
                        </h3>
                        <div className="relative h-80 w-full">
                        <Image
                            src={s3Static + "blog/living/mitsubishi-R410a-single-split.png"}
                            fill
                            sizes="(max-width: 768px) 100vw, 33vw"
                            style={{ objectFit: "contain" }}
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            alt="Mitsubishi Electric Starmex R410a Single Split"
                        />
                        </div>
                        <p className="text-sm leading-7">
                        The Mitsubishi Starmex GN Series offers high-performance cooling with energy-saving technology. Designed for comfort and durability, this unit ensures fresh, clean air using advanced filtration systems.
                        </p>
                    </article>

                    {/* R410a Multi Split */}
                    <article className="border shadow-lg rounded-lg p-5 space-y-4 hover:shadow-xl transition duration-300">
                        <h3 className="text-xl md:text-2xl font-bold text-center">
                        Starmex R410a Multi Split
                        </h3>
                        <div className="relative h-80 w-full">
                        <Image
                            src={s3Static + "blog/living/mitsubishi-R410a-multi-split.png"}
                            fill
                            sizes="(max-width: 768px) 100vw, 33vw"
                            style={{ objectFit: "contain" }}
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            alt="Mitsubishi Electric Starmex R410a Multi Split"
                        />
                        </div>
                        <p className="text-sm leading-7">
                        Perfect for small rooms, the G Series delivers ultra-quiet performance and comes with a 5-Tick NEA energy efficiency rating. Its smart capacity control ensures optimal comfort with lower electricity bills.
                        </p>
                    </article>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                    {/* R32 Single Split */}
                    <article className="border shadow-lg rounded-lg p-5 space-y-4 hover:shadow-xl transition duration-300">
                        <h3 className="text-xl md:text-2xl font-bold text-center">
                        Starmex R32 Single Split
                        </h3>
                        <div className="relative h-80 w-full">
                        <Image
                            src={s3Static + "blog/living/mitsubishi-R32-single-split.png"}
                            fill
                            sizes="(max-width: 768px) 100vw, 33vw"
                            style={{ objectFit: "contain" }}
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            alt="Mitsubishi Electric Starmex R32 Single Split"
                        />
                        </div>
                        <p className="text-sm leading-7">
                        The GP Series features an eco-friendly R32 refrigerant with low GWP, offering excellent air purification (PM2.5 filter), energy efficiency, and sleek design—ideal for modern households.
                        </p>
                    </article>

                    {/* R32 Multi Split */}
                    <article className="border shadow-lg rounded-lg p-5 space-y-4 hover:shadow-xl transition duration-300">
                        <h3 className="text-xl md:text-2xl font-bold text-center">
                        Starmex R32 Multi Split
                        </h3>
                        <div className="relative h-80 w-full">
                        <Image
                            src={s3Static + "blog/living/mitsubishi-R32-multi-split.png"}
                            fill
                            sizes="(max-width: 768px) 100vw, 33vw"
                            style={{ objectFit: "contain" }}
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            alt="Mitsubishi Electric Starmex R32 Multi Split"
                        />
                        </div>
                        <p className="text-sm leading-7">
                        Designed for energy-conscious consumers, this R32 multi-split model offers powerful cooling, low noise operation, and features like PM2.5 filters and Dual Barrier Coating for healthier air.
                        </p>
                    </article>
                    </div>
                </section>
                {/* Price Section */}
                <section className="text-center space-y-4">
                    <h3 className="text-xl md:text-2xl font-bold uppercase  text-amber-800">
                    New System Price Range
                    </h3>
                    <p className="text-md max-w-3xl mx-auto leading-7">
                    Planning to install a new Mitsubishi Electric aircon? Prices vary depending on model type, system capacity, features, and installation. Contact our team for a customized, competitive quote tailored to your space.
                    </p>
                </section>

                {/* Warranty Section */}
                <section className="text-center space-y-4">
                    <h3 className="text-xl md:text-2xl font-bold uppercase text-amber-800">
                    Manufacturer Warranty Coverage
                    </h3>
                    <p className="text-md max-w-3xl mx-auto leading-7">
                    Every Mitsubishi Electric air conditioning system comes with a manufacturer’s warranty, typically ranging from 1 to 5 years. Our consultants can guide you through the warranty options that best suit your needs.
                    </p>
                </section>
            </section>
            <section className='py-10 px-2 max-w-5xl mx-auto space-y-6'>
                <h2 className='font-bold text-center text-2xl md:text-3xl uppercase'>
                    Mitsubishi Aircon Error Codes & Common Problems
                </h2>

                <div className='space-y-4 leading-8 text-sm md:text-base'>
                    <p>
                    Experiencing issues with your Mitsubishi Electric air conditioner? Understanding common error codes and symptoms can help you identify problems early and avoid costly repairs. Below is a comprehensive guide to the most frequently reported Mitsubishi aircon problems and what the error codes typically mean.
                    </p>

                    <h3 className='font-semibold text-lg md:text-xl'>Frequent Mitsubishi Air Conditioner Issues</h3>
                    <ul className='list-disc px-6 space-y-1'>
                    <li>Insufficient cooling or weak airflow</li>
                    <li>Unusual noises or vibration from the unit</li>
                    <li>Water leakage from the indoor unit</li>
                    <li>Sensor malfunctions or control board failures</li>
                    <li>Compressor or fan motor not functioning</li>
                    </ul>

                    <p>
                    Most Mitsubishi AC systems are designed to display diagnostic codes when something goes wrong. These error codes are typically shown on the remote control or wall-mounted controller.
                    </p>

                    <h3 className='font-bold text-lg md:text-xl pt-4 text-orange-600'>“P” Series Error Codes – Mitsubishi Aircon Troubleshooting</h3>
                    <div className='overflow-x-auto'>
                    <table className='w-full border-collapse border border-slate-400 text-sm'>
                        <caption className='text-left text-xs italic mb-2 text-gray-500'>P-series codes usually relate to power, pressure, and communication issues between components.</caption>
                        <thead className='bg-gray-100 text-orange-600'>
                        <tr>
                            <th className='py-2 px-3 border border-slate-300'>Error Code</th>
                            <th className='py-2 px-3 border border-slate-300'>Issue Description</th>
                        </tr>
                        </thead>
                        <tbody className='text-gray-700'>
                        {[
                            ["P0", "Abnormal power supply voltage"],
                            ["P1", "High-pressure protection (excessive discharge pressure)"],
                            ["P2", "Low-pressure protection (insufficient suction pressure)"],
                            ["P3", "Discharge temperature protection (high temp)"],
                            ["P4", "Inverter compressor drive malfunction"],
                            ["P5", "Current sensor fault"],
                            ["P6", "Inverter module (IPM) or control circuit error"],
                            ["P7", "Communication error between indoor and outdoor units"],
                            ["P8", "Outdoor fan motor malfunction"],
                            ["P9", "Indoor fan motor malfunction"]
                        ].map(([code, desc]) => (
                            <tr key={code}>
                            <td className='py-2 px-3 text-center font-semibold text-orange-600 border border-slate-300'>{code}</td>
                            <td className='py-2 px-3 border border-slate-300'>{desc}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>

                    <h3 className='font-bold text-lg md:text-xl pt-6 text-orange-600'>“E” Series Error Codes – Mitsubishi AC System Faults</h3>
                    <div className='overflow-x-auto'>
                    <table className='w-full border-collapse border border-slate-400 text-sm'>
                        <caption className='text-left text-xs italic mb-2 text-gray-500'>E-series codes often relate to temperature, fan motor, or sensor failures.</caption>
                        <thead className='bg-gray-100 text-orange-600'>
                        <tr>
                            <th className='py-2 px-3 border border-slate-300'>Error Code</th>
                            <th className='py-2 px-3 border border-slate-300'>Issue Description</th>
                        </tr>
                        </thead>
                        <tbody className='text-gray-700'>
                        {[
                            ["E101", "Communication error between indoor and outdoor units"],
                            ["E202", "Abnormal compressor temperature"],
                            ["E303", "High-pressure protection triggered"],
                            ["E404", "Fan motor rotation speed abnormality"],
                            ["E505", "Indoor fan motor failure"],
                            ["E606", "Incorrect refrigerant charge level"],
                            ["E707", "Outdoor fan motor fault"],
                            ["E808", "Discharge pipe temperature abnormality"],
                            ["E909", "Faulty thermistor or temperature sensor"],
                            ["E1010", "Power supply interruption or voltage fluctuation"]
                        ].map(([code, desc]) => (
                            <tr key={code}>
                            <td className='py-2 px-3 text-center font-semibold text-orange-600 border border-slate-300'>{code}</td>
                            <td className='py-2 px-3 border border-slate-300'>{desc}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>

                    <p className='mt-6'>
                    Please note that error codes may differ slightly based on your Mitsubishi Electric model and aircon type. For accurate diagnosis and fast repair, contact our certified Mitsubishi aircon technicians today.
                    </p>
                </div>
            </section>
            <BlogsList blogs={airconBlogs}/>
        </div>
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
